// Per-tenant favicon + touch icon. Uses the uploaded logo image when present,
// otherwise generates an SVG mark from the brand initials + primary colour, so
// every operator's browser tab is white-labelled automatically.

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function initialsOf(name) {
  const parts = (name || "FO").trim().split(/\s+/);
  const ini = parts.length >= 2 ? parts[0][0] + parts[1][0] : (name || "FO").slice(0, 2);
  return ini.toUpperCase();
}

function svgMark(initials, primaryHsl) {
  const bg = `hsl(${primaryHsl || "240 10% 4%"})`;
  const svg =
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'>` +
    `<rect width='64' height='64' rx='15' fill='${bg}'/>` +
    `<text x='32' y='34' font-family='Outfit, Manrope, system-ui, sans-serif' ` +
    `font-size='30' font-weight='700' fill='white' text-anchor='middle' ` +
    `dominant-baseline='central'>${initials}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

function setLink(rel, href) {
  let link = document.head.querySelector(`link[rel='${rel}']`);
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
}

/** @param {{logoUrl?:string|null, name?:string, primary?:string}} opts */
export function setFavicon({ logoUrl, name, primary } = {}) {
  const href = logoUrl
    ? (logoUrl.startsWith("http") ? logoUrl : `${BACKEND}${logoUrl}`)
    : svgMark(initialsOf(name), primary);
  setLink("icon", href);
  setLink("apple-touch-icon", href);
}

/** FleetOS / Graphikpro house mark for non-tenant (marketing/auth) pages. */
export function setFleetOSFavicon() {
  setFavicon({ name: "Graphikpro", primary: "240 10% 4%" });
}
